import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "generate-crew-roster-modal",
  "data-toggle": "modal"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "invite_a_friend_modal_label"
}, " Generate Crew Roster ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "d-flex flex-column" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Choose period", -1)
const _hoisted_11 = { class: "fv-plugins-message-container" }
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = { class: "d-flex justify-content-end mt-4" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Generate ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleModal(false, null))),
            "aria-label": "Close"
          }, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Form, {
            ref: "formComponent",
            onSubmit: _ctx.handleSubmit,
            class: "w-100 d-flex flex-column",
            "validation-schema": _ctx.validationSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_Field, { name: "date" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_el_date_picker, _mergeProps({
                      modelValue: _ctx.selectedDate,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDate) = $event))
                    }, field, {
                      size: "large",
                      class: "w-100",
                      type: "daterange",
                      "start-placeholder": "Start Date",
                      "end-placeholder": "End Date"
                    }), null, 16, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_ErrorMessage, { name: "date" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light me-4",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleModal(false, null)))
                }, " Close "),
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary",
                  disabled: _ctx.loading
                }, [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15))
                    : _createCommentVNode("", true),
                  _hoisted_16
                ], 8, _hoisted_14)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ])
    ])
  ]))
}